import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular';
import { WidgetsModule } from '../../widgets/widgets.module';
import { ContactListComponent } from './contact-list.component';
import { ResearchLayoutModule } from '../../components/research-layout/research-layout.module';
import { ContactModule } from '../contact/contact.module';
import { ContactScreenModule } from '../../components/contact-screen/contact-screen.module';
import { ContactPanelModule } from '../../components/contact-panel/contact-panel.module';
import { ExchangeImportListDialogComponent } from '../../components/exchange/exchange-import-list-dialog/exchange-import-list-dialog.component';
import { ExchangeImportCheckDialogComponent } from '../../components/exchange/exchange-import-check-dialog/exchange-import-check-dialog.component';
import { ExchangeImportCheckDialogService } from '../../components/exchange/exchange-import-check-dialog/exchange-import-check-dialog.service';
import { ExchangeImportListDialogService } from '../../components/exchange/exchange-import-list-dialog/exchange-import-list-dialog.service';
import { ExchangeImportDuplicateDialogComponent } from '../../components/exchange/exchange-import-duplicate-dialog/exchange-import-duplicate-dialog.component';
import { DialogService } from '../../services/dialog.service';
import { ContactListFilterComponent } from './contact-list-filter/contact-list-filter.component';
import { ContactListBulkEditComponent } from './contact-list-bulk-edit/contact-list-bulk-edit.component';

@NgModule({
    imports: [
        AgGridModule,
        AgGridModule,
        CommonModule,
        WidgetsModule,
        ResearchLayoutModule,
        ContactModule,
        ContactScreenModule,
        ContactPanelModule,
    ],
    declarations: [
        ContactListComponent,
        ExchangeImportDuplicateDialogComponent,
        ExchangeImportListDialogComponent,
        ExchangeImportCheckDialogComponent,
        ContactListFilterComponent,
        ContactListBulkEditComponent,
    ],
    exports: [
        ContactListComponent
    ],
    providers: [
        DialogService,
        ExchangeImportCheckDialogService,
        ExchangeImportListDialogService,
    ],
})
export class ContactListModule { }
